<script setup lang="ts">
    import type { IWidgetProps } from '~/composables/widgets';
    import type { ProductSpecData, SpecificationWidgetData } from '~/@types/cms';

    /**
     * specification widget fetches the specification data from the current page
     */
    const props = defineProps<IWidgetProps<SpecificationWidgetData>>();
    const { getValueSequence } = useWidget(props);
    const appStore = useAppStore();

    const specs = computed(() => {
        const specification = appStore.pageCache?.page?.content?.specification;
        if (!specification) return [];
        return getValueSequence<ProductSpecData>(specification);
    });
</script>
<template>
    <atm-grid
        class="cms-specification-widget w-full gap-4"
        no-margin>
        <template v-for="spec in specs">
            <div
                v-if="spec"
                :key="spec.id"
                class="col-span-3">
                <atm-heading
                    level="h4"
                    class="mb-3 overflow-hidden text-ellipsis">
                    {{ spec.title }}
                </atm-heading>
                <div class="text-block">
                    <renderer-html :content="spec.description" />
                </div>
            </div>
        </template>
    </atm-grid>
</template>
